import { useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import FormStrip from "../../components/FormStrip";
import { useTranslation } from "react-i18next";
import { MainWrapper, PrimaryTab, PrimaryTabs, PrimaryTabsWrapper, StyledDivider, SubTab, SubTabs, SubTabsWrapper } from "../../components/StyledComponent";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { BackButton, Loader } from "@egovernments/digit-ui-react-components";
import { useHistory } from "react-router-dom";
import SubStep1 from "./Step1/SubStep1";
import getRevalData from "./getRevalData";
import SubStep3 from "./Step1/SubStep3";
import SubStep2 from "./Step1/SubStep2";
import SubStep4 from "./Step1/SubStep4";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import SearchSummary from "./Summary/SearchSummary";
import ReactToPrint from "react-to-print";
import ButtonWrapper from "../../components/Button";
import { Card } from "@mui/material";
import { citizenBaseUrl } from "../../components/data";

const RevalidationPortal = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const subTabLabels = [
    { label: "General Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
  ];
  const tenantId = Digit.ULBService.getStateId();
  const { id } = useParams();
  const history = useHistory();
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("RV_CURRENT_SUBTAB") || 0);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("RV_CURRENT_TAB") || 0);

const location = useLocation();



let applicationData = location?.state?.data;
let isAppDataLoading = false;
console.log(applicationData,"revalLocationDatabEFORE");
if (!applicationData) {
  ({ applicationData, isAppDataLoading } = getRevalData(id));
}
console.log(applicationData,"revalLocationDatabaFTER");
  const { info: userInfo } = Digit.UserService.getUser();
  const isEmployee = false
  const Modal = useModal();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_REVALIDATION", applicationData);
  const componentRef = useRef();
  
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };
  const handleTabChange = async (nextTabNo, formData = null) => {
    console.log("nextTabNooooo", nextTabNo);
    
      if (formData) {
        const data = { ...params, ...formData };
        try {
          if (nextTabNo === 4) {
            data.workflow = { action: 'MAKE_PAYMENT', assignes: null };
          } else {
            data.workflow = { action: "UPLOAD_DOC", assignes: null };
          }
          updateApiCall.mutate(
            { BPA: data },
            {
              onSuccess: () => {
                onSelect("", data);
                if (nextTabNo === 4) {
                  if(params?.status === "REVERT_TO_APPLICANT"){
                    Modal("Application Submited", `Your Application ${params?.applicationNo} has been sent to department for further approval`, "success");
                  } else{
                    if (params?.taxHeadEstimates?.length > 1) {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[1]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  } else {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[0]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  }
                    //Modal("Application Submited", `Your Application ${params?.applicationNo} has been sent to the plot Owner for his consent`, "success");
                  }
                  // clearParams();
                  // Digit.SessionStorage.del("FORM_MAP_REVALIDATION");
                  // Digit?.SessionStorage.del("FASTPAS_ID");
                  // Digit?.SessionStorage.del("SUMMARY_TAB");
                  // setTimeout(() => {
                  //   resetFormMTDocs();
                  // }, 0);
                  // Digit.SessionStorage.del("RV_CURRENT_TAB");
                  // Digit.SessionStorage.del("RV_CURRENT_SUBTAB");
                  // history.push(`${citizenBaseUrl}/profile`);
                } else {
                  if (nextTabNo === 3) {
                    Digit.SessionStorage.set("SUMMARY_TAB", true);
                    setSummaryshow(true);
                  }
                   Modal(
                    "Application Updated",
                    `Application Updated Successfully!`,
                    "success"
                  )
                  setActiveTab(nextTabNo);
                  Digit.SessionStorage.set("RV_CURRENT_TAB", nextTabNo);
                  // setActiveTab(nextTabNo);
                  // Digit.SessionStorage.set("RV_CURRENT_TAB", nextTabNo)
                }
              },
              onError: () => {
                Modal("Update Error", "Something went wrong!!", "error");
              },
            }
          );
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
      setActiveTab(nextTabNo);
      Digit.SessionStorage.set("RV_CURRENT_TAB", nextTabNo);
    };
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);

  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      // if (activeTab === 0 && selectedSubTab === 0 && !id) {
      //   Digit.OBPSService.create({ BPA: data }, tenantId)
      //     .then((res) => {
      //       if (res?.BPA?.length > 0) {
      //         onSelect("", { ...data, ...res.BPA[0] }, true);
      //            Modal(
      //           "Application Created",
      //           `Application Created Successfully!`,
      //           "success"
      //         )
      //         setSelectedSubTab(nextSubTab);
      //         Digit.SessionStorage.set("RV_CURRENT_SUBTAB", nextSubTab);
      //       }
      //     })
      //     .catch((e) => {
      //       Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
      //     });
      // } 
       {
        try {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
          updateApiCall.mutate(
            { BPA: data },
            {
              onSuccess: (res) => {
                onSelect("", res?.BPA?.[0]);
                setSelectedSubTab(nextSubTab);
                console.log("nextSubTabFromUpdaterv", nextSubTab,res?.BPA?.[0]);
                Digit.SessionStorage.set("RV_CURRENT_SUBTAB", nextSubTab);
              },
              onError: () => {
                Modal("Update Error", "Something went wrong!!", "error");
              },
            }
          );
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("RV_CURRENT_SUBTAB", nextSubTab);
    }
  };

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              userInfo={userInfo}
              handleTabChange={handleTabChange}
              handleSubTabChange={handleSubTabChange}
              setFormData={setParams}
              initFormMTDocs={initFormMTDocs}
            />
          );
        case 1:
          return <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 2:
          return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 3:
          return <SubStep4 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} handleSubTabChange={handleSubTabChange}/>;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return <Step2 formData={params} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={isEmployee} />;
    } else if (activeTab === 2) {
      return <Step3 formData={params} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={isEmployee} />;
    } else if (activeTab === 3) {
      return <Step4 formData={params} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={isEmployee} />;
    } else if (activeTab === 4 && params?.applicationNo) {
      return (
        <div>
          <Card style={{ width: "90%", margin: "0 auto" }} ref={componentRef}>
            <SearchSummary
              id={params?.applicationNo}
              ref={componentRef}
              handleDeclarationChange={handleDeclarationChange}
              declarationChecked={declarationChecked}
              showDeclaration = {true}
            />
          </Card>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ReactToPrint
                trigger={() => (
                  <ButtonWrapper 
                  variant="contained" 
                  color="success" 
                  size="medium" 
                  label="Print" 
                  sx={{ backgroundColor: "#7600bc" }}>
                    Print Summary
                  </ButtonWrapper>
                )}
                content={() => componentRef.current}
              />
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Preview"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(0)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Make Payment"
                type="submit"
                sx={{ backgroundColor: "#157CB3" }}
                onClick={() => handleTabChange(4, params)}
                disabled={!declarationChecked}
              />
            </div>
          </div>
        </div>
      );
    }
  };
  if (isAppDataLoading) {
    return <Loader />;
  }
  
  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <FormStrip formName={"Revalidation/Time Extension Form"} />
      <PrimaryTabsWrapper className="technical-profession-section">
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          <PrimaryTab label="Drawing Details" />
          {/* <PrimaryTab label="Site Inspection" /> */}
          <PrimaryTab label="Fees" />
          <PrimaryTab label="Summary" />
          <PrimaryTab label="Application History" />
          {/* <PrimaryTab label="Letter and Plan" /> */}
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}

      {renderContent()}
    </MainWrapper>
  );
};

export default RevalidationPortal;
